<template>
  <div id="app">
    <div id="logo-div" @click="backToDashboard()">
      <img src="./assets/logo.png" width=400 />
      <h3 id="speyside_text">Speyside Full Bore Gun Club</h3>
    </div>  
    <br>
    <router-view/>
  </div>
</template>

<script>

import Router from './router/index.js'

export default {
  name: 'app',
  data() {
    return {};
  },

  methods: {
    backToDashboard() {
      Router.push({ name: 'Dashboard' })
    }
  }
}
</script>

<style>
#login-logout {
  margin-top: 10px;
  text-align: left;
}
#logo-div {
  cursor: pointer;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 5px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 2px;
}
#speyside_text {
  color: black;
  font-size: 13pt;
  font-family: 'Courier New', Courier, monospace;
}
</style>
